module.exports = __webpack_public_path__ + "static/media/image.41d1a796.png";